// src/components/common/DataCardList.jsx
import React from "react";
import "../../styles/DataCardList.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faDeleteLeft } from "@fortawesome/free-solid-svg-icons";

export default function DataCardList({
  data,
  loading = false,
  emptyMessage = "No data found.",
  renderContent,
  renderActions,
  onEdit,
  onDelete,
}) {
  if (loading) return <div className="loading-state">Loading...</div>;

  // Robustly normalize a few common response shapes into an array
  let dataArray = [];
  if (!data) dataArray = [];
  else if (Array.isArray(data)) dataArray = data;
  else if (Array.isArray(data?.data?.items)) dataArray = data.data.items;
  else if (Array.isArray(data?.data?.docs)) dataArray = data.data.docs;
  else if (Array.isArray(data?.data)) dataArray = data.data;
  else if (Array.isArray(data?.items)) dataArray = data.items;
  else if (Array.isArray(data?.docs)) dataArray = data.docs;
  else if (typeof data === 'object' && Object.keys(data).length > 0 && (data.id || data.art_id || data._id || data.title || data.name)) dataArray = [data];
  else dataArray = [];

  if (!dataArray || dataArray.length === 0) {
    return <div className="empty-state">{emptyMessage}</div>;
  }

  const getId = (item) => item?.id || item?.art_id || item?._id || item?.artId || item?.uid || null;

  return (
    <div className="card-list">
      {dataArray.map((item, index) => (
        <div className="data-card" key={getId(item) || index}>
          {renderContent(item, index)} {/* Pass index as second argument */}
          <div className="card-actions">
            {renderActions ? (
              renderActions(item, index)
            ) : (
              <>
                {onEdit && (
                  <button
                    className="card-action-btn edit-btn"
                    onClick={() => onEdit(item)}
                    title="Edit"
                    aria-label="Edit item"
                  >
                    <FontAwesomeIcon icon={faPenToSquare} />
                  </button>
                )}

                {onDelete && (
                  <button
                    className="card-action-btn delete-btn"
                    onClick={() => onDelete(getId(item) || index)}
                    title="Delete"
                    aria-label="Delete item"
                  >
                    <FontAwesomeIcon icon={faDeleteLeft} />
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}